<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner != 0"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <mat-card *ngIf="!hatLizenvereinbarungAkzeptiert">
    Sie haben der Datenverarbeitung nicht zugestimmt. Die Web-Anwendung kann aus diesem Grund nicht von Ihnen genutzt werden.

<br>
    <button
    (click)="onClickZuEinverstaendniserklaerung()"
    mat-raised-button
    color="primary"
    class="custom-btn buttons-left"
    type="button"
  >
  <fa-icon
  [icon]="faArrowLeft"
  class="ml-1 icon-vertical-align"
></fa-icon>
  zurück zur Einverständniserklärung

  </button>
 
  </mat-card>

<span *ngIf="hatLizenvereinbarungAkzeptiert">

  <mat-card >
    <mat-tab-group
      mat-align-tabs="start"
      dynamicHeight="true"
      animationDuration="0ms"
      (selectedIndexChange)="selectedChange($event)"
    >
      <mat-tab label="Direkteingabe" class="tab-reiter">
        <mat-card>
          <div class="row">
            <!--  <div class="col-md-12">
              <p>
                Bitte wählen sie Ihre Nuts 2. Region in dem ihr Betrieb steht,
                tragen die Betriebsdaten ein und klicken auf 'Zum Ergebnis'.
              </p>
            </div>
-->
            <div class="row-zweispaltig">
              <mat-form-field
                class="seite-an-seite-padding-right"
                appearance="fill"
              >
                <mat-label
                  >Region
                  <fa-icon
                    [icon]="faInfoCircle"
                    class="ml-1 icon-info-select"
                    matTooltipClass="tooltip-format"
                    matTooltip="Zu der Auswahl einer Region siehe weitere Informationen unter „Hilfe“ - „Regionen“."
                  ></fa-icon
                ></mat-label>

                <mat-select
                  disableRipple
                  (selectionChange)="setRegion($event)"
                  [formControl]="regionFormControl"
                  [errorStateMatcher]="matcher"
                  required
                >
                  <mat-option
                    *ngFor="let region of regionen"
                    [value]="region.idRegion"
                  >
                    <span
                      [style.padding-left]="getPaddingLeft(region.regionLevel)"
                    >
                      - {{ region.regionDe }}
                    </span>
                  </mat-option>
                </mat-select>

                <mat-error *ngIf="regionFormControl.hasError('required')"
                  >Bitte wählen Sie eine Region aus.</mat-error
                >
              </mat-form-field>

              <mat-form-field
                class="seite-an-seite-padding-left"
                appearance="fill"
              >
                <mat-label>Betriebsname</mat-label>
                <input
                  matInput
                  required
                  [errorStateMatcher]="matcher"
                  [formControl]="bezeichnungFormControl"
                  (change)="setBezeichnung($event)"
                />
                <mat-error *ngIf="bezeichnungFormControl.hasError('required')">
                  Bitte geben Sie einen Betriebsnamen ein.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12" id="content_daten"></div>
          </div>
        </mat-card>
      </mat-tab>

      <mat-tab label="CSV/Zip-Upload" class="tab-reiter">
        <mat-card>
          <div class="row-zweispaltig">
            <div class="column-zweispaltig-gross">
              <p>
                Sie können Betriebsdaten importieren und im Block
                klassifizieren.<br />Laden Sie hierzu eine oder mehrere Dateien
                (Dateiformat: CSV oder eine ZIP mit CSV) hoch.
              </p>
            </div>

            <div class="column-zweispaltig-klein">
              <div class="row">
                <input
                  type="file"
                  class="file-input"
                  (change)="onFileSelected($event)"
                  multiple="multiple"
                  #fileUpload
                />

                <div class="file-upload">
                  <button
                    mat-mini-fab
                    color="primary"
                    class="upload-btn"
                    (click)="fileUpload.click()"
                  >
                    <mat-icon>attach_file</mat-icon>
                  </button>

                  {{ fileName }}
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </mat-card>

  <div class="spacer"></div>

  <mat-card>
    <div class="col-md-12 text-right">
      <button
        (click)="onClickClearAll()"
        mat-raised-button
        color="primary"
        class="custom-btn"
        type="button"
      >
        <fa-icon [icon]="faUndo" class="ml-1 icon-vertical-align"></fa-icon>
        Zurücksetzen
      </button>

      <button
        (click)="onClickZuErgebnisseVorbereitung()"
        mat-raised-button
        color="primary"
        class="custom-btn buttons-right"
        type="button"
        [disabled]="isZumErgebnisDisabled"
      >
        Zum Ergebnis
        <fa-icon
          [icon]="faArrowRight"
          class="ml-1 icon-vertical-align"
        ></fa-icon>
      </button>
    </div>
  </mat-card>
</span>
</div>
